import React, { Component } from 'react';
import { formatarReal } from '../../util/numberUtil';

export class SeguroEncomenda extends Component {

    render() {
        return (
            <>
                {this.props.encomenda.habilitadoSeguro ? <>                
                  {this.props.encomenda.seguroEncomenda.habilitadoValorDeclarado && <>
                    <strong>Valor declarado</strong>{this.props.isRecibo && <br/>} <strong>do produto: </strong>{formatarReal(this.props.encomenda.seguroEncomenda.valorProduto)}<br /></>}
                  
                  {this.props.encomenda.seguroEncomenda.habilitadoValorNotaFiscal && <>
                    <strong>Valor nota fiscal: </strong>{formatarReal(this.props.encomenda.seguroEncomenda.valorTotalNotaFiscal)}<br /></>}
                <strong>Seguro:</strong> {formatarReal(this.props.encomenda.valorSeguro)}<br />
                <strong>Valor:</strong> {formatarReal(this.props.encomenda.valorEncomenda)}<br />
                <strong>Valor Total:</strong> {formatarReal(this.props.encomenda.valorTotal)}
              </>
                : <><strong>Valor Total:</strong> {formatarReal(this.props.encomenda.valor)}</>}
            </>
        )
    }
}